// extracted by css-extract-rspack-plugin
export default {"UpsellCardComponent":"YWOO6","Large":"E53TJ","MainStack":"eYeZj","Default":"ZcNgJ","Title":"BCM4l"};